var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1713_5004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5001 1.75C8.9001 1.75 10.9001 3.75 10.9001 6.15C10.9001 8.55 8.9001 10.55 6.5001 10.55C4.1001 10.55 2.1001 8.55 2.1001 6.15C2.1001 3.75 4.1001 1.75 6.5001 1.75ZM6.5001 0.25C3.2001 0.25 0.600098 2.85 0.600098 6.15C0.600098 9.45 3.2001 12.05 6.5001 12.05C9.8001 12.05 12.4001 9.45 12.4001 6.15C12.4001 2.85 9.8001 0.25 6.5001 0.25Z",
    fill: "#DDE9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 13.75L9.90015 9.65002",
    stroke: "#DDE9F4",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1713_5004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4,
    height: 13.5,
    fill: "white",
    transform: "translate(0.600098 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/IconSearch.1d070f4282cbfbb9a6ba548c7834bb71.svg";
export { ForwardRef as ReactComponent };